import createReactComponent from '../createReactComponent';
export default createReactComponent('tally-one', 'TallyOne', [["path",{"d":"M4 4v16","key":"svg-0"}]]);